import { Component, OnInit } from "@angular/core";
import { MessageService } from "primeng/api";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import {
  MissingSecurityBreakDownEntry,
  QualityGateFilter,
} from "src/api/models";
import { QualityGateService } from "src/api/services";
import { preventLeadingSpaceKey } from "src/core/utils/input-validation.utils";

@Component({
  selector: "app-missing-security-processed",
  // imports: [],
  templateUrl: "./processed.component.html",
  styleUrl: "./processed.component.css",
  standalone: false,
})
export class MissingSecurityProcessedComponent implements OnInit {
  ref!: DynamicDialogRef;
  readonly paginator = { pageSize: 10, pageNumber: 1, totalCount: 0 };
  processedMissingSecurities: MissingSecurityBreakDownEntry[] = [];
  selectedSecurity: any[] = [];
  first = 0;
  rows = 10;
  isLoading: boolean = false;
  issuerName?: string;
  filingId?: number;
  insiderName?: string;
  constructor(
    private _qualityGateService: QualityGateService,
    public dialogService: DialogService,
    private _messageService: MessageService
  ) {}

  ngOnInit(): void {}
  getProcessedMissingSecurities() {
    const params: QualityGateFilter = {
      pageNumber: this.paginator.pageNumber,
      pageSize: this.paginator.pageSize,
      processStatus: "PROCESSED",
      qualityGateType: "Missing_Security_Break_Down",
      issuerName: this.issuerName,
      insiderName: this.insiderName,
      filingId: this.filingId,
    };
    this.isLoading = true;
    this._qualityGateService.view(params).subscribe({
      next: (value) => {
        this.processedMissingSecurities =
          value.missingSecurityBreakDownEntries ?? [];
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.paginator.totalCount =
          this.processedMissingSecurities?.[0]?.totalCount ?? 0;
        this.isLoading = false;
      },
    });
  }

  pageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }

  loadData(event: any) {
    if (event.first > 0 && this.paginator.pageSize != event.rows) {
      this.paginator.pageNumber = 1;
      this.first = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.first = event.first;
    }
    this.paginator.pageSize = event.rows;
    this.getProcessedMissingSecurities();
  }
  onSearch() {
        const fid = String(this.filingId ?? '').trim();
  if (fid && !/^\d+$/.test(fid)) {
    return;
  }
    this.first = 0;
    this.paginator.pageNumber = 1;
    this.getProcessedMissingSecurities();
  }
   preventSpaceKey(event: KeyboardEvent): void {
      preventLeadingSpaceKey(event);
    }
}
